/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Daysavailable1Inputs */

const de__field_daysavailable1 = /** @type {(inputs: _Field_Daysavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Tage`)
};

/**

* @param {_Field_Daysavailable1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_daysavailable1 = /** @type {((inputs?: _Field_Daysavailable1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Daysavailable1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_daysavailable1(inputs)
});
export { _field_daysavailable1 as "_field_daysAvailable" }